module.exports = __webpack_public_path__ + "static/media/18-2.2fc544c7.mp3";